/** Removes the static HTML boot splash once React has mounted. */
export function removeStaticBootSplash() {
  if (typeof document === 'undefined') {
    return;
  }
  const splash = document.getElementById('boot-splash');
  if (!splash) {
    return;
  }
  splash.classList.add('boot-splash--hidden');
  window.setTimeout(() => {
    splash.remove();
  }, 400);
}
